import { ReactNode } from "react";
import { cn } from "@/utils/cn";

type SectionLayoutProps = {
  children: ReactNode;
  id?: string;
  className?: string;
  noPaddingX?: boolean;
  noPaddingY?: boolean;
  noGap?: boolean;
};

export const SectionLayout = ({
  children,
  id,
  className,
  noPaddingX = false,
  noPaddingY = false,
  noGap = false,
}: SectionLayoutProps) => {
  return (
    <section
      id={id}
      className={cn(
        "flex w-full flex-col items-center",
        !noPaddingX && "px-24 ph:px-72 md:px-96 lg:px-120 xl:px-168",
        !noPaddingY && "py-72",
        !noGap && "gap-48",
        className,
      )}
    >
      {children}
    </section>
  );
};
